var arrow = {
    selectors: {
        trigger: '[data-arrow-trigger]',
        target: '[data-arrow-target]',
    },
    init: function () {
        var self = this;

        $(self.selectors.trigger).on('click', function (e) {
            e.preventDefault();

            var $this = $(this),
                targetID = $this.attr('data-arrow-trigger'),
                $target = $('[data-arrow-target="' + targetID + '"]');

            var scroll = new SmoothScroll();
            scroll.animateScroll($target[0]);
        });

        if (
            window.location.hash &&
            window.location.hash === '#scroll-to-content'
        ) {
            history.replaceState(null, null, ' ');
            $(self.selectors.trigger).trigger('click');
        }
    },
};

export { arrow };
